<template>
  <div class="hom-page">
    <Header />
    <div class="home-content">
      <div class="lunbo">
        <el-carousel height="300px">
          <el-carousel-item
            ><el-image
              style="width: 100%"
              src="img/product-banner.jpg"
              fit="fill"
            ></el-image
          ></el-carousel-item>
          <el-carousel-item
            ><el-image
              style="width: 100%"
              src="img/product-banner1.jpg"
              fit="fill"
            ></el-image
          ></el-carousel-item>
        </el-carousel>
      </div>
      <div class="wrap">
        <div class="header">
          <div class="header-left">
            <span v-if="language === 'ch'">关于我们</span
            ><span v-else>About US</span>
          </div>
          <div class="header-right">
            <span v-if="language === 'ch'">首页 > 关于我们 > 织袋</span
            ><span v-else>Home > About Us > Woven bag</span>
          </div>
        </div>
        <div class="conten-wrap">
          <div class="left">
            <div class="left-item" @click="handleExpand">
              <i class="el-icon-caret-right" v-if="!expandflag"> </i>
              <i class="el-icon-caret-bottom" v-else> </i>
              <span v-if="language === 'ch'">手袋</span
              ><span v-else>Handbags</span>
              <div class="sencond-warp" v-show="expandflag">
                <div
                  @click.stop="handleProduct(1)"
                  :class="['active', type === 1 ? 'selected' : '']"
                >
                  <span v-if="language === 'ch'">皮编织袋</span
                  ><span v-else> Leather woven bag</span>
                </div>
                <div
                  @click.stop="handleProduct(2)"
                  :class="['active', type === 2 ? 'selected' : '']"
                >
                  <span v-if="language === 'ch'">藤编织袋</span
                  ><span v-else>Rattan woven bag</span>
                </div>
                <div
                  @click.stop="handleProduct(3)"
                  :class="['active', type === 3 ? 'selected' : '']"
                >
                  <span v-if="language === 'ch'">钩织袋</span
                  ><span v-else>Crochet bag</span>
                </div>
              </div>
            </div>
            <div   :class="['left-item','active', type === 4 ? 'selected' : '']" @click.stop="handleProduct(4)">
              <i class="el-icon-caret-right"> </i
              ><span v-if="language === 'ch'">鞋</span><span v-else>Shoes</span>
            </div>
            <div   :class="['left-item','active', type === 5 ? 'selected' : '']" @click.stop="handleProduct(5)">
              <i class="el-icon-caret-right"> </i
              ><span v-if="language === 'ch'">饰品</span
              ><span v-else>Jewelry</span>
            </div>
          </div>
          <div class="right">
            <div class="item-list">
              <div class="item" v-for="(item, index) in curList" :key="index">
                <img
                  style="width: 180px; height: 180px"
                  :src="item.src"
                  @click="showImagePreview(item.src)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "../components/header.vue";
import Footer from "../components/footer.vue";
export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      type: 1,
      curList: [],
      language: "",
      tList: [
        {
          src: require("../assets/p1.jpg"),
        },
        {
          src: require("../assets/p2.jpg"),
        },
      ],
      gList: [
        {
          src: require("../assets/t1.jpg"),
        },
        {
          src: require("../assets/t2.jpg"),
        },
      ],
      pList: [
        {
          src: require("../assets/g1.jpg"),
        },
        {
          src: require("../assets/g2.jpg"),
        },
        {
          src: require("../assets/g3.jpg"),
        },
        {
          src: require("../assets/g4.jpg"),
        },
        {
          src: require("../assets/g5.jpg"),
        },
        {
          src: require("../assets/g6.jpg"),
        },
        {
          src: require("../assets/g7.jpg"),
        },
        {
          src: require("../assets/g8.jpg"),
        },
        {
          src: require("../assets/g9.jpg"),
        },
        {
          src: require("../assets/g10.jpg"),
        },
        {
          src: require("../assets/g12.jpg"),
        },
        {
          src: require("../assets/g13.jpg"),
        },
        {
          src: require("../assets/g14.jpg"),
        },
        {
          src: require("../assets/g16.jpg"),
        },
        {
          src: require("../assets/g17.jpg"),
        },
      ],
      xList: [
        {
          src: require("../assets/x1.jpg"),
        },
        {
          src: require("../assets/x2.jpg"),
        },
        {
          src: require("../assets/x3.jpg"),
        },
      ],
      sList: [
        {
          src: require("../assets/s1.jpg"),
        },
        {
          src: require("../assets/s2.jpg"),
        },
        {
          src: require("../assets/s3.jpg"),
        },
      ],
      expandflag: false,
    };
  },
  methods: {
    handleExpand() {
      this.expandflag = !this.expandflag;
    },
    handleProduct(val) {
      this.type = val;
      if (val === 1) {
        this.curList = this.pList;
      } else if (val === 2) {
        this.curList = this.tList;
      } else if (val === 3) {
        this.curList = this.gList;
      } else if (val === 4) {
        this.curList = this.xList;
      } else if (val === 5) {
        this.curList = this.sList;
      }
    },
    showImagePreview(img) {
      const image = new Image();
      image.src = img;
      image.onload = () => {
        // 创建弹出层
        const previewContainer = document.createElement("div");
        previewContainer.style.position = "fixed";
        previewContainer.style.zIndex = 99999;
        previewContainer.style.top = 0;
        previewContainer.style.bottom = 0;
        previewContainer.style.left = 0;
        previewContainer.style.right = 0;
        previewContainer.style.backgroundColor = "rgba(0,0,0,0.8)";
        previewContainer.style.display = "flex";
        previewContainer.style.justifyContent = "center";
        previewContainer.style.alignItems = "center";
        document.body.appendChild(previewContainer);
        // 在弹出层中添加图片
        const previewImage = document.createElement("img");
        previewImage.src = img;
        previewImage.style.maxWidth = "80%";
        previewImage.style.maxHeight = "80%";
        previewContainer.appendChild(previewImage);
        // 点击弹出层，关闭预览
        previewContainer.addEventListener("click", () => {
          document.body.removeChild(previewContainer);
        });
      };
    },
  },
  created() {},
  mounted() {
    this.handleProduct(1);
    this.language = localStorage.getItem("curlanguage");
  },
};
</script>

<style scoped>
.hom-page {
  height: 100%;
  widows: 100%;
}
a {
  text-decoration: none;
}
.home-content {
  width: 1130px;
  margin: 0 auto;
  height: 1110px;
}
.lunbo {
  margin: 12px 0;
}
.wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  line-height: 48px;
}
.header-left {
  border-bottom: 1px solid #cccccc;
  width: 25%;
}
.header-right {
  border-bottom: 1px solid #cccccc;
  width: 70%;
  color: #cccccc;
  display: flex;
  justify-content: flex-end;
  float: right;
  font-size: 14px;
}
.conten-wrap {
  margin-top: 24px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.left {
  line-height: 30px;
  width: 25%;
}
.left-item {
  cursor: pointer;
}
.active:hover {
  color: blue;
}
.selected {
  color: blue;
}
.sencond-warp {
  margin-left: 16px;
}
.right {
  width: 70%;
}
.item-list {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  margin-left: -10px;
}
.item {
  margin: 10px;
}
</style>
